'use client';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export interface SegmentedToggleOption {
  value: string;
  label: string;
}

export interface SegmentedToggleProps {
  value: string;
  options: SegmentedToggleOption[];
  onChange: (value: string) => void;
  size?: 'small' | 'medium' | 'large';
}

export function SegmentedToggle({
  value,
  options,
  onChange,
  size = 'small',
}: SegmentedToggleProps) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      size={size}
      onChange={(_event, next) => {
        if (next !== null) onChange(next);
      }}
    >
      {options.map((option) => (
        <ToggleButton key={option.value} value={option.value}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}

export default SegmentedToggle;
